import React from 'react';
import classnames from 'classnames';
import {UploadFromUrlForm} from './upload-from-url-form';
import {CurrentPageStore} from '@/store/content-optimizer/currentPage';
import {observer} from 'mobx-react-lite';
import {EditorState, ContentState} from 'draft-js';
import {getLocalesByKey as t} from '@/utils/translation';
import {useRouter} from 'next/router';
import style from './step-one.module.scss';
import {routes} from '@/utils/const';
interface IStep1Props {
  store: CurrentPageStore;
}

const Step1: React.FC<IStep1Props> = observer<IStep1Props>(
  ({store}: IStep1Props) => {
    const {setCurrentStep, setIsCreateFromScratch, setIsFirstArticleEdit} = store;

    const router = useRouter();

    const onStartFromScratchClick = async () => {
      setIsCreateFromScratch(true);
      // we are setting loading state for target keywords here to false
      // so it doesnt get set inside editContent method, because in that case
      // editing content while target keywords are still fetching would stop target keywords loader from showing
      store.setIsFetchingTargetKw(false);

      store.analysis?.clearUrl();
      await store.editContent(EditorState.createWithContent(ContentState.createFromText('')));
      // await store.editTitle('');
      await store.updateContentLoadedAt(); // trigger editor, reload content from store.
      setIsFirstArticleEdit(false);
      setCurrentStep(2);
      router.push(
        `/${routes.landingPageOptimizer}/${router.query!.uuid}/`,
        undefined,
        {shallow: true},
      );
    };

    return (
      <div className={style.welcome}>
        <div className={style.welcomeHeader}>{t('select-option-start')}.</div>
        <br/>
        <div className={style.welcomeSubHeader}>
          {t('seo-assistant-description')}
        </div>
        <br/>
        <br/>
        <div className={style.welcomeCards}>
          <div className={style.welcomeCard}>
            <div className={style.welcomeCardHeader}>
              {t('blank-page')}
            </div>
            <div className={style.welcomeCardSubHeader}>{t('create-scratch')}</div>
            <div className={classnames(style.button, style.purple)} onClick={() => onStartFromScratchClick()}>
              {t('start-scratch-button')}
            </div>
          </div>
          <div className={style.divider}></div>
          <div className={style.welcomeCard}>
            <div className={style.welcomeCardHeader}>
              {t('from-url')}
            </div>
            <div className={style.welcomeCardSubHeader}>{t('upload-from-url')}</div>
            <UploadFromUrlForm store={store}/>
          </div>
        </div>
      </div>
    );
  },
);

export {Step1};
